import { getBlob, getDownloadURL, ref, uploadBytes, uploadString } from "firebase/storage";
import { storage } from "../firebase";
import { updateProfileImage } from "./firebaseAuth";
import { updateUserImage } from "./firebaseFirestore";

export const upload = async (file, uid) => {
  try {
    const fileRef = ref(storage, `profileImages/${uid}.png`)
    await uploadBytes(fileRef, file)
    const newImageUrl = await getDownloadURL(fileRef)
    await updateProfileImage(newImageUrl)
    await updateUserImage(uid, newImageUrl)
  } catch (error) {
    console.log(error)
  }
}

export const uploadFormBanner = async (file,eventId, fileName, fileType) => {

  let type
  switch (fileType) {
    case 'image/png':
      type = '.png'

      break;
    case 'image/jpg':
      type = '.jpg'

      break;
    case 'image/jpeg':
      type = '.jpeg'
      break;
    default:
      type = '.png'
      break;
  }
  try {
    const fileRef = ref(storage, `eventImages/${eventId}/form/${fileName}${type}`)
    await uploadBytes(fileRef, file)
    const newImageUrl = await getDownloadURL(fileRef)
    return newImageUrl
  } catch (error) {
    console.log(error)
  }
}

export const uploadMailImage = async (file, eventId, fileName, fileType) => {

  let type
  switch (fileType) {
    case 'image/png':
      type = '.png'

      break;
    case 'image/jpg':
      type = '.jpg'

      break;
    case 'image/jpeg':
      type = '.jpeg'
      break;
    default:
      type = '.png'
      break;
  }
  try {
    const fileRef = ref(storage, `eventImages/${eventId}/Mail/${fileName}${type}`)
    await uploadBytes(fileRef, file)
    const newImageUrl = await getDownloadURL(fileRef)
    return newImageUrl
  } catch (error) {
    console.log(error)
  }
}

export const uploadGuestQrCode = async (file, guestId, eventId) => {
  try {
    const fileRef = ref(storage, `guestsQrCodes/event-${eventId}/${guestId}.png`)
    await uploadString(fileRef, file, 'data_url')
    const newImageUrl = await getDownloadURL(fileRef)
    return newImageUrl
  } catch (error) {
    console.log(error)
  }
}

export const uploadGroupAttachment = async (file, groupId) => {
  try{
    const fileRef = ref(storage, `groupImages/${groupId}/attachment`)
    await uploadBytes(fileRef, file)
    const urlPath = await getDownloadURL(fileRef)
    return urlPath
  }catch(error){
    console.log(error)
  }
}

export const getFileBlob = async (groupId) => {
  try{
    const fileRef = ref(storage, `groupImages/${groupId}/attachment`)
    const blob = await getBlob(fileRef)
    console.log(blob)
    return blob 
  }catch(error){
    console.log(error)
  }
}